import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "lab",
    serviceName: "graphql",
    query: gql`
      query lab(
        $ids: [String]
        $title: String
        $alias: String
        $is_active: Int
        $lat: String
        $lng: String
        $distance: String
        $page: Int
        $limit: Int
        $orderBy_field: String # >createsd_at
        $orderBy_direction: String # >DESC , ASC
        $status_ids: [String]
        $manager_ids: [String]
        $creator_ids: [String]
        $updator_ids: [String]
        $for_admin: Int # >0 , 1
        $city_id: String
        $state_id: String
      ) {
        lab(
          ids: $ids
          title: $title
          alias: $alias
          is_active: $is_active
          lat: $lat
          lng: $lng
          distance: $distance
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
          status_ids: $status_ids
          manager_ids: $manager_ids
          creator_ids: $creator_ids
          updator_ids: $updator_ids
          for_admin: $for_admin
          city_id: $city_id
          state_id: $state_id
        ) {
          data {
            id
            title
            is_favorite
            manager {
              firstname
              lastname
            }
            media {
              id
              full_url
            }
            default_units {
              id
            }
          }
          total
        }
      }
    `,
  },
  delete: {
    name: "deleteLab",
    serviceName: "admin",
    query: gql`
      mutation deleteLab($ids: [String]!) {
        deleteLab(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  assignment: {
    name: "lab",
    serviceName: "grapghql",
    query: gql`
      query lab($ids: [String]) {
        lab(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
